import type { MeasureType } from "../types/config";

/** Smallest dimension we accept, in mm. */
export const MIN_DIMENSION_MM = 100;

/**
 * Default total clearance (speling) subtracted per dimension when the customer
 * enters a "sponningmaat". PLACEHOLDER — the real values per glass type / frame
 * profile are supplied in Fase 2; this is a representative stand-in.
 */
export const DEFAULT_SPELING_MM = 4;

/**
 * "Driemaat": glass wholesale bills dimensions rounded UP to 30 mm steps
 * (1000 → 1020). Mirrors the Timmers/Baka webshop calculation exactly.
 */
export function ceil30(mm: number): number {
  const remainder = mm % 30;
  return remainder === 0 ? mm : mm + 30 - remainder;
}

/** Billable area: driemaat dims, in m² rounded to 2 decimals (Baka). */
export function billableArea(widthMm: number, heightMm: number): number {
  return Math.round(((ceil30(widthMm) * ceil30(heightMm)) / 1e6) * 100) / 100;
}

export interface NetDimensions {
  netWidthMm: number;
  netHeightMm: number;
}

/**
 * Resolves the net production size. For "sponning" the clearance is subtracted
 * from each dimension ("Wij produceren uw glas op X mm"); "glas" is returned
 * unchanged. The result is what the engine prices and what we cut.
 */
export function resolveNetDimensions(
  input: { measureType: MeasureType; widthMm: number; heightMm: number },
  spelingMm: number = DEFAULT_SPELING_MM,
): NetDimensions {
  if (input.measureType === "sponning") {
    return {
      netWidthMm: input.widthMm - spelingMm,
      netHeightMm: input.heightMm - spelingMm,
    };
  }
  return { netWidthMm: input.widthMm, netHeightMm: input.heightMm };
}
